import { GQL_TYPES, RELATION_TYPE } from "../constants";
import { DB_DELETE, DB_INSERT, DB_UPDATE } from "./nodeTypes";
export const endP = (start, end, pct) => {
  return {
    x: (start.x + (end.x - start.x)) * pct,
    y: (start.y + (end.y - start.y)) * pct
  };
};
export const iconInstanceMd = icon => {
  const fontType = require(`react-icons/md`);
  return fontType[icon];
};
export const hexToRgb = hex => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : null;
};
export const associationDefinition = (
  relationship,
  fromModelName,
  toModelName,
  fromPrimaryKey,
  toPrimaryKey,
  isFromModel
) => {
  switch (relationship) {
    case RELATION_TYPE.BELONGS_TO_RELATION:
      return {
        origin: isFromModel ? fromPrimaryKey : toPrimaryKey,
        target: isFromModel
          ? `${fromModelName}_${fromPrimaryKey}`
          : `${toModelName}_${toPrimaryKey}`,
        relation: relationship
      };
    case RELATION_TYPE.HAS_MANY_RELATION:
      return {
        origin: isFromModel
          ? `${toModelName}_${toPrimaryKey}`
          : `${fromModelName}_${fromPrimaryKey}`,
        target: isFromModel ? toPrimaryKey : fromPrimaryKey,
        relation: relationship
      };
    default:
      return null;
  }
};
export const assemblyForeignKey = (key, type) => ({
  name: key,
  type: type,
  notNull: true,
  foreignKey: true
});
export const workFlow_type = nodes => {
  //identifica si en los nodos existe actualizacion, eliminacion,insercion
  const tmpNode = Object.entries(nodes)
    .map(([key, o]) => o)
    .find(
      o => o.type === DB_UPDATE || o.type === DB_INSERT || o.type === DB_DELETE
    );
  if (tmpNode) {
    return GQL_TYPES.MUTATION;
  }
  return GQL_TYPES.QUERY;
};
